const tableMetadata = [
  {
    id: 'name',
    renderingField: 'name',
    width: '25%',
    numeric: false,
    disablePadding: false,
    label: 'Name',
    alignment: 'left',
  },
  {
    id: 'description',
    renderingField: 'description',
    width: '50%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Description',
    alignment: 'left',
  },
  {
    id: 'action',
    renderingField: 'action',
    width: '25%',
    numeric: false,
    disablePadding: false,
    label: '',
    alignment: 'right',
  },
];

export default tableMetadata;
